import { isMac } from 'conversations/utils/PlatformUtil'

const optionAltKey = () => {
  return isMac ? 'option' : 'alt'
}

const optionAltIcon = () => {
  return isMac ? '⌥' : 'Alt'
}

const shiftIcon = () => {
  return isMac ? '⇧' : 'Shift'
}

const commandControlKey = () => {
  return isMac ? 'command' : 'ctrl'
}

const commandControlIcon = () => {
  return isMac ? '⌘' : 'Ctrl'
}

const createMacCommand = (keys: string[]) => {
  return keys.join('')
}

const createWindowsCommand = (keys: string[]) => {
  return keys.join(' + ')
}

const createCommand = (keys: string[]) => {
  return isMac ? createMacCommand(keys) : createWindowsCommand(keys)
}

export {
  createMacCommand,
  createWindowsCommand,
  createCommand,
  commandControlKey,
  optionAltKey,
  optionAltIcon,
  commandControlIcon,
  shiftIcon,
}
